import { SET_TOKEN, SET_USUARIO, SET_CONFIGURACION } from '../../types';

export default function(state = null, action) {
    switch (action.type) {
        case SET_TOKEN:
            return { ...state, token: action.payload };
        case SET_USUARIO:
            return { ...state, usuario: action.payload };
        case SET_CONFIGURACION:
            return { ...state, configuracion: action.payload };
        default:
            return state;
    }
}
